<script>
import Icon from '../icon';

export default {
  components: {
    Icon
  },

  computed: {
    prosecutorsAre: {
      get () {
        return this.$store.state.databaseSearch.prosecutorsAre;
      },
      set (value) {
        this.$store.commit('databaseSearch/setProsecutorsAre', value);
      }
    }
  },

  mounted() {
    let initialProsecutorsAre = this.$route.query.prosecutorsAre;
    if (!!initialProsecutorsAre) {
      this.prosecutorsAre = initialProsecutorsAre;
    }
    else {
      this.prosecutorsAre = ''
    }
  },

  destroyed() {
    this.$store.commit('databaseSearch/clearDistrictFactes');
  }
}
</script>

<template lang="html">
  <div class="DatabaseSearch-facets u-mt3">
    <div class="DatabaseSearch-facets-col1">
      <label for="database-district-prosecutors-are">Prosecutors Are</label>
      <div class="js-custom-select">
        <select id="database-district-prosecutors-are" v-model="prosecutorsAre">
          <option value="">Elected or Appointed</option>
          <option value="election">Elected</option>
          <option value="appointment">Appointed</option>
        </select>
        <icon icon="arrow-down"></icon>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// district-facets.vue?15ac1ce2